import { render, staticRenderFns } from "./FeedBackMelhoriasSugeridas.vue?vue&type=template&id=57957460&scoped=true"
import script from "./FeedBackMelhoriasSugeridas.vue?vue&type=script&lang=js"
export * from "./FeedBackMelhoriasSugeridas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57957460",
  null
  
)

export default component.exports